import HeadquartersFinalPage from './HeadquartersFinalPage';

export default HeadquartersFinalPage;
